jQuery(document).ready(function(e) {

    // SLIDE UP HEADER ON SCROLL

    $(window).scroll(function() {
        if (jQuery(window).scrollTop() >= 149) {
            jQuery("body").addClass("sticky");
        }
        if (jQuery(window).scrollTop() < 149) {
            jQuery("body").removeClass("sticky");
        }
    });

    if (jQuery(window).scrollTop() >= 149) {
        jQuery("body").addClass("sticky");
    }

    // TOGGLE NAVIGATION

    jQuery("#hamburger_icon").on('click', function(){
        jQuery(this).fadeOut(100, function(){
           jQuery(this).toggleClass('active').fadeIn(100);

        });

        jQuery("header nav").toggleClass('active');
        checkNavigation();

    });

    function checkNavigation(){

        var windowHeight = jQuery(window).height()  - 64;

        resetnavigation();

        setTimeout(function(){
            var NavigationHeight = jQuery("header nav").height();
            //console.log("window : " + windowHeight);
            //console.log("nav : " + NavigationHeight);

            if(NavigationHeight>windowHeight) {

                jQuery("header nav > ul").css({
                    "height" : windowHeight,
                    "overflow-y" : "scroll"
                });
            }

        },500)
        
    }

    function resetnavigation(){

        jQuery("header nav > ul").css({
            "height" : "auto",
            "overflow-y" : "visible"
        });
    }

    var navTimer;
    $(window).resize(function() {
        clearTimeout(navTimer);
        navTimer = setTimeout(checkNavigation(), 200); // Timeout limits the number of calculations   
    });

    var navigationHeight = jQuery("header nav ul").height();
    jQuery("header nav.active").css({
        "height": navigationHeight + "px"
    });

    jQuery("header nav li.dropdown > a").on('click', function(e){
        e.preventDefault();
        jQuery(this).parent().toggleClass('active');
        checkNavigation();
    });
    


    // footer navigation on mobile/tablet

    jQuery(".footer_column_links").on("click", function(){
        jQuery(this).toggleClass("active");
    });

    // search
    jQuery("#top_navigation_search .search_box").on("focus", function(){
        jQuery(this).addClass("active");
    });

    jQuery("#top_navigation_search .search_box").on("blur", function(){
        setTimeout(function(){
            jQuery("#top_navigation_search .search_box").removeClass("active");
        },500);
    });

    jQuery("#go").on("click", function(){
        jQuery(this).next("input").addClass("active");
    });


    jQuery("#search_icon").on("click", function(){
        if(!jQuery("#sticky_search input.search_box").hasClass("active")){
            jQuery("#sticky_search").toggleClass("active");
            jQuery("#sticky_search input.search_box").focus();
        } else {
            jQuery("#sticky_search").toggleClass("active");
            jQuery("#sticky_search input.search_box").blur();
        }
    });


    jQuery("#quantity_selector .ctrl").on("click", function(){

        var currentQuantity = jQuery("#quantity").val();
        console.log(currentQuantity);

        if(jQuery(this).hasClass("increase")) {
            newQuantity = parseInt(currentQuantity) + 1;
        } else {
            newQuantity = parseInt(currentQuantity) - 1;
        }

        console.log(newQuantity);

        if(newQuantity>0 && newQuantity < 11){
            jQuery("#quantity_selector_value").html(newQuantity);
            jQuery("#quantity").val(newQuantity);
        }

    });

    jQuery(".product_content_header").on("click", function(){
        jQuery(this).parent().toggleClass("active");
    });

    // instagram feed
    // (function(){
    //  $.ajax({
    //      type: "GET",
    //      dataType: "jsonp",
    //      cache: false,
    //      //url: "https://api.instagram.com/v1/users/219752184/media/recent/?access_token=219752184.213a26e.300ce8915f62467f9853add42be169ab",
    //      url: "https://api.instagram.com/v1/users/360429755/media/recent/?access_token=5a823a500ec34f68aae5bca250e27f45",
    //      success: function(data) {

    //          for (var i = 0; i < 4; i++) {
    //              //console.log(data.data[i]);
    //              $("#instagram_feed").append("<a href='" + data.data[i].link + "' target='_blank'><img src=" + data.data[i].images.thumbnail.url+ " /></a>");
    //          }

    //      }
    //  });

    // })();
    // end instagram feed

    // var feed = new Instafeed({
    //     userId: '4160883675824b06a60d6890303f29aa',
    //     target: 'instagram_feed'
    //     get: 'user',
    //     userId: 360429755, // Ex: 1374300081
    //     accessToken: '360429755.4160883.7ec20f1bc3804103ba5468c901a59c42'
    // });
    // feed.run();


    var userFeed = new Instafeed({
        get: 'user',
        userId: '360429755',
        accessToken: '360429755.4160883.354108af6ead4ce59b191e00952cf495',
        target: 'instagram_feed',
        limit: '3',
        template: '<a href="{{link}}" target="_blank"><img src="{{image}}" /></a>'
    });
    userFeed.run();


    //var token = '360429755.4160883.c400c825a66646ec9c1af93473d987d9',

    //username = 'christianrhymes',
    // username = 'broochini',
    // num_photos = 4;
     
    // $.ajax({ // the first ajax request returns the ID of user rudrastyh
    //     url: 'https://api.instagram.com/v1/users/search',
    //     dataType: 'jsonp',
    //     type: 'GET',
    //     data: {access_token: token, q: username}, // actually it is just the search by username
    //     success: function(data){
    //         //console.log(data);
    //         $.ajax({
    //             url: 'https://api.instagram.com/v1/users/' + data.data[0].id + '/media/recent', // specify the ID of the first found user
    //             dataType: 'jsonp',
    //             type: 'GET',
    //             data: {access_token: token, count: num_photos},
    //             success: function(data2){
    //                 //console.log(data2);
    //                 for(x in data2.data){
    //                     $("#instagram_feed").append('<a href="' + data2.data[x].link + '" target="_blank"><img src="'+data2.data[x].images.standard_resolution.url+'"></a>');  
    //                 }
    //                 },
    //             error: function(data2){
    //                 console.log(data2);
    //             }
    //         });
    //     },
    //     error: function(data){
    //         console.log(data);
    //     }
    // });


    if(document.getElementById('product-select')) {
        //changeVariant();
    }

    function changeVariant(){
        var productSelect = document.getElementById('product-select');
        var variantId = productSelect.options[productSelect.selectedIndex].innerHTML;  

        var variantArray = variantId.split(" / "); 
        var variantColor = variantArray[0];
        var variantSize = variantArray[1].split(" - ")[0];

        jQuery("#variant_value_Color").html(variantColor);
        jQuery("#variant_value_Size").html(variantSize);

        //console.log(variantColor);
        //console.log(variantSize);
    }

    jQuery("#product-select").on("change", function(){
        changeVariant();
        console.log('change');
        //console.log(variantSize);
    });


    if($('.collection-slideshow')) {

        function initCycle() {
            var width = $(document).width(); // Getting the width and checking my layout
            if ( width < 641 ) {
                $('.collection-slideshow').cycle({
                    fx: 'carousel',
                    swipe: true,
                    speed: 300,
                    manualSpeed: 300,
                    slides: '> .collection_product',
                    next: '#next',
                    prev: '#prev',
                    carouselVisible: 2,
                    timeout: 0,
                    carouselFluid: true,
                    easing : 'easeOutQuint',
                    log: false
                });
                // console.log('Init Mobile');
            } else if ( width < 769 ) {  
                $('.collection-slideshow').cycle({
                    fx: 'carousel',
                    swipe: true,
                    speed: 300,
                    manualSpeed: 300,
                    slides: '> .collection_product',
                    next: '#next',
                    prev: '#prev',
                    carouselVisible: 3,
                    timeout: 0,
                    carouselFluid: true,
                    easing : 'easeOutQuint',
                    log: false
                });
            } else {
                $('.collection-slideshow').cycle({
                    fx: 'carousel',
                    swipe: true,
                    speed: 300,
                    manualSpeed: 300,
                    slides: '> .collection_product',
                    next: '#next',
                    prev: '#prev',
                    carouselVisible: 5,
                    timeout: 0,
                    carouselFluid: true,
                    easing : 'easeOutQuint',
                    log: false
                });
            }
        }
        initCycle();

        function reinit_cycle() {
            var width = $(window).width(); // Checking size again after window resize
            if ( width < 641 ) {
                $('.collection-slideshow').cycle('destroy');
                reinitCycle(2);
            } else if ( width < 769 ) {
                $('.collection-slideshow').cycle('destroy');
                reinitCycle(3);
            } else {
                $('.collection-slideshow').cycle('destroy');
                reinitCycle(5);
            }
        }

        function reinitCycle(visibleSlides) {
            $('.collection-slideshow').cycle({
                fx: 'carousel',
                swipe: true,
                speed: 300,
                manualSpeed: 300,
                slides: '> .collection_product',
                next: '#next',
                prev: '#prev',
                carouselVisible: visibleSlides,
                timeout: 0,
                carouselFluid: true,
                easing : 'easeOutQuint',
                log: false
            });
        }

        var reinitTimer;
        $(window).resize(function() {
            clearTimeout(reinitTimer);
            reinitTimer = setTimeout(reinit_cycle, 100); // Timeout limits the number of calculations   
        });

        setTimeout(function(){
            $("#page_home_category").addClass("active");
        }, 1500);

    }

    

    function initLookbookCycle() {
        var width = $(document).width(); // Getting the width and checking my layout
        if ( width < 641 ) {
            $('.lookbook_slider').cycle({
                fx: 'carousel',
                swipe: true,
                speed: 500,
                manualSpeed: 800,
                slides: '> .lookbook_slide',
                next: '#next',
                prev: '#prev',
                carouselVisible: 2,
                timeout: 0,
                carouselFluid: true,
                easing : 'easeOutQuint'
            });
            // console.log('Init Mobile');
        } else if ( width < 769 ) {  
            $('.lookbook_slider').cycle({
                fx: 'carousel',
                swipe: true,
                speed: 500,
                manualSpeed: 800,
                slides: '> .lookbook_slide',
                next: '#next',
                prev: '#prev',
                carouselVisible: 2,
                timeout: 0,
                carouselFluid: true,
                easing : 'easeOutQuint'
            });
        } else {
            $('.lookbook_slider').cycle({
                fx: 'carousel',
                swipe: true,
                speed: 500,
                manualSpeed: 800,
                slides: '> .lookbook_slide',
                next: '#next',
                prev: '#prev',
                carouselVisible: 3,
                timeout: 0,
                carouselFluid: true,
                easing : 'easeOutQuint'
            });
        }
    }

    if($('.lookbook_slider').length) {
        initLookbookCycle();
    }

    function reinit_lookbook_cycle() {
        var width = $(window).width(); // Checking size again after window resize
        if ( width < 641 ) {
            $('.lookbook_slider').cycle('destroy');
            reinitLookbookCycle(2);
        } else if ( width < 769 ) {
            $('.lookbook_slider').cycle('destroy');
            reinitLookbookCycle(2);
        } else {
            $('.lookbook_slider').cycle('destroy');
            reinitLookbookCycle(3);
        }
    }

    function reinitLookbookCycle(visibleSlides) {
        $('.lookbook_slider').cycle({
            fx: 'carousel',
            swipe: true,
            speed: 500,
            manualSpeed: 800,
            slides: '> .lookbook_slide',
            next: '#next',
            prev: '#prev',
            carouselVisible: visibleSlides,
            timeout: 0,
            carouselFluid: true,
            easing : 'easeOutQuint'
        });
    }

    var reinitLookbookimer;
    $(window).resize(function() {
        clearTimeout(reinitLookbookimer);
        reinitLookbookimer = setTimeout(reinit_lookbook_cycle, 100); // Timeout limits the number of calculations   
    });

    setTimeout(function(){
        $("#page_home_category").addClass("active");
    }, 1500);





    if($('#product_thumb_container')) {

        //$("#product_image img").CloudZoom();
        if($("body").hasClass("productPage")) {
            switchImage($('#product .product_thumb:eq(0) a').attr('href'), null, $('#product_image img')[0]);
        }

        var numberOfThumbs = jQuery(".product_thumb").length;
        var width = $(document).width(); 

        if((numberOfThumbs>5 && width >= 1000) || (numberOfThumbs>3 && width < 1000)) {

            $("#product_thumb_container .ctrl").show();

            var width = $(document).width(); // Getting the width and checking my layout
            if ( width < 769 ) {  
                createThumbSlide(false,3);
            } else if ( width < 1000 ) {  
                createThumbSlide(true,3);
            } else {
                createThumbSlide(true,5);
            }

        }

        function reinit_thumbslide_cycle() {
            var width = $(window).width(); // Checking size again after window resize
            

            if ( width < 769 ) {
                $('#product_thumb_container_slider').cycle('destroy');
                var numberOfThumbs = jQuery(".product_thumb").length;
                if(numberOfThumbs <= 3) {
                    $("#product_thumb_container .ctrl").hide();
                } else {
                    $("#product_thumb_container .ctrl").show();
                }
                createThumbSlide(false,3);

            } else if ( width < 1000 ) {  
                $('#product_thumb_container_slider').cycle('destroy');
                var numberOfThumbs = jQuery(".product_thumb").length;
                if(numberOfThumbs <= 3) {
                    $("#product_thumb_container .ctrl").hide();
                } else {
                    $("#product_thumb_container .ctrl").show();
                }
                createThumbSlide(true,3);
                
            } else {
                $('#product_thumb_container_slider').cycle('destroy');
                var numberOfThumbs = jQuery(".product_thumb").length;
                if(numberOfThumbs <= 5) {
                    $("#product_thumb_container .ctrl").hide();
                } else {
                    $("#product_thumb_container .ctrl").show();
                }

                createThumbSlide(true,5);
                
            }
        }
        var reinitThumbSlideTimer;
        $(window).resize(function() {
            clearTimeout(reinitThumbSlideTimer);
            reinitThumbSlideTimer = setTimeout(reinit_thumbslide_cycle, 100); // Timeout limits the number of calculations   
        });

        function createThumbSlide(hasVertical,slidesInview){

            //console.log(slidesInview);

            $('#product_thumb_container_slider').cycle({
                fx: 'carousel',
                swipe: true,
                speed: 500,
                manualSpeed: 800,
                slides: '> .product_thumb',
                next: '#next',
                prev: '#prev',
                carouselVisible: slidesInview,
                carouselVertical: hasVertical,
                timeout: 0,
                log: false,
                //carouselFluid: true,
                easing : 'easeOutQuint'
            });

            setTimeout(function(){
                $('#product .product_thumb a').on('click', function(e) { 
                    e.preventDefault();
                    switchImage($(this).attr('href'), null, $('#product_image img')[0]);
                });
            },500);
        }
        
        

    }

    $('#cart-target a, #basket_icon').on('click', function(e){
        if($('#minibasket_container').hasClass("active")) {
            //hideMiniBasket();
            return true;
        } else {
            e.preventDefault();
            showMiniBasket();
        }
        
    });

    $('#minibasket_close').on('click', function(e){
        e.preventDefault();
        hideMiniBasket();
    });

    

    showMiniBasket = function() {

        $('#minibasket #minibasket_list').html('');
        $('#minibasket #minibasket_total').html('');
        $('#minibasket #minibasket_message').html('');


        $.ajax({
            type: 'GET',
            url: '/cart.json',
            dataType: 'jsonp',
            success: function(data) { 
                var item_count = data['item_count'];

                //If there are items in cart
                if(item_count > 0) {

                    console.log(data);
                    //console.log(item_count);

                    for(var i=0;i<data['items'].length;i++){
                        
                        var product_title = data['items'][i]['product_title'];
                        var product_size = data['items'][i]['variant_options'][0];
                        //var product_size = '';
                        var product_id = data['items'][i]['variant_id'];
                        color_product_id = product_id;
                        var quantity = data['items'][i]['quantity'];
                        var line_price = (data['items'][i]['line_price']/100) * js_vat_tax_rate;
                        //line_price = line_price.toFixed(2);
                        var url = data['items'][i]['url'];
                        var image_url = data['items'][i]['image'];

                        $('#minibasket #minibasket_list').append('<li class="cart_product"><div class="thumb"><a href="'+ url +'"><img src="'+ image_url +'"/></a></div><div class="product_description"><span class="title">'+ product_title +'</span><br/>Size: '+ product_size +'<br/><div id="minibasket-color-' + product_id + '"></div>Qty - '+ quantity +' <br/><span class="price">£'+ line_price.toFixed(2) +'</div><div class="minibasket_remove" data-id="' + product_id + '">remove</div></div></li>');

                        // $.getJSON('/products/' + data['items'][i]['handle'] + '.js', function(product) {
                            
                        //     if(product['tags'][0]) {
                                
                        //         console.log('tags');
                        //         console.log(product['tags'][0]);
                        //         console.log

                        //         var product_color = product['tags'][0];
                        //         $("#minibasket-color-" + color_product_id).html('Colour: ' + product_color);
                        //     }
                        // });


                    }

                    var total = ((data['total_price']/100) * js_vat_tax_rate).toFixed(2);
                    //total = total.toFixed(2);
                    $('#minibasket #minibasket_total').append("Total - £" + total);

                } else {
                    $('#minibasket #minibasket_message').append("<p>Your Basket is Currently Empty</p>");
                }

            }

        });

        $('#minibasket_container').addClass("active").fadeIn(400, function(){
            $('.minibasket_remove').on("click", function(){
                var product_id = $(this).attr("data-id");
                console.log(product_id);
                jQuery.post('/cart/update.js', 
                    "updates[" + product_id + "]=0");
                
                hideMiniBasket();
                setTimeout(function(){
                    showMiniBasket();
                },500);
                

            });
        });
        // $('#minibasket').show();

    }

    hideMiniBasket = function() {
        $('#minibasket_container').removeClass("active").fadeOut(400, function(){
            $('#minibasket #minibasket_list').html('');
            $('#minibasket #minibasket_total').html('');
            $('#minibasket #minibasket_message').html('');
        });
    }
    


});







